import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import LatestUpdatesSection from './components/LatestUpdatesSection';
import HotComicsSection from './components/HotComicsSection';
import EditorPickSection from './components/EditorPickSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <LatestUpdatesSection />
          <HotComicsSection />
          <EditorPickSection />
          <CTASection />
        </article>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '布丁漫画网',
            alternateName: 'PuddingComic',
            url: 'http://591chaxin.cn/',
            description: '布丁漫画网是国内领先的正版漫画在线阅读平台，提供洞洞杂货铺等海量精品漫画的下拉式免费阅读体验。',
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: 'http://591chaxin.cn/search?q={search_term_string}',
              },
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '布丁漫画网',
            url: 'http://591chaxin.cn/',
            description: '国内领先的正版漫画在线阅读平台',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '400-888-6666',
              contactType: 'customer service',
              email: 'hello@591chaxin.cn',
              areaServed: 'CN',
              availableLanguage: 'Chinese',
            },
            address: {
              '@type': 'PostalAddress',
              streetAddress: '望京SOHO T3 12层',
              addressLocality: '北京',
              addressRegion: '朝阳区',
              addressCountry: 'CN',
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            url: 'http://591chaxin.cn/',
            name: '洞洞杂货铺漫画-漫画全集下拉式免费阅读-布丁漫画网',
            description: '洞洞杂货铺漫画全集下拉式免费阅读就在布丁漫画网，无删减内容+流畅加载，全章节覆盖。',
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'http://591chaxin.cn/',
                },
              ],
            },
          }),
        }}
      />
    </>
  );
}